module.exports = __webpack_public_path__ + "static/media/waybill-electronic.2b357b93.webp";